module.exports = __webpack_public_path__ + "static/media/ic-credential.28054002.svg";